import React, { useState } from "react"
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button,
  Input,
} from "@nextui-org/react"
import { apiRoute, linksUrl } from "../constants/enum"
import { useNavigate } from "react-router-dom"
import { setLogin } from "../state/authSlice"
import { useDispatch } from "react-redux"
import { ToastContainer } from "react-toastify"
import { usePost } from "../api/reactQueryCustomHooks"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "react-toastify/dist/ReactToastify.css" //react toastify css

function Login() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [errors, setErrors] = useState({})
  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  })

  const resetValues = () => {
    setFormData({
      username: "",
      password: "",
    })
  }


  const { isPending, mutate: login } = usePost({
    url: apiRoute.userMaster.fetchLogin,
    queryKey: "auth",
    resetValues,
    onSuccessTasks: (data) => {
      navigate(linksUrl.client.clientMaster)
      console.log(data)
      dispatch(
        setLogin({
          user: data.user,
          token: data.accessToken,
          refreshToken: data.refreshToken,
        })
      )
    }
    ,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    // Validate the form before submission
    if (validateForm()) {
      // Perform form submission logic here
      login({
        data: {
          username: formData.username,
          password: formData.password,
        },
      })
    } else {
      console.log("Form has errors. Please fix them.")
    }
  }

  const validateForm = () => {
    const newErrors = {}

    // Validate username
    if (formData.username.trim() === "") {
      newErrors.username = "Client Code is required"
    }

    // Validate password
    if (formData.password.trim() === "") {
      newErrors.password = "Password is required"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }
  console.log(errors)
  return (
    <div className="flex items-center justify-center items-baseline pt-20  bg-white h-screen">
      <ToastContainer />

     <Card className="w-full max-w-md rounded-2xl border border-gray-200 bg-white/80 shadow-xl backdrop-blur-sm">
  <CardHeader className="flex flex-col items-center gap-2 pt-8">
    <div className="flex h-14 w-14 items-center justify-center rounded-full bg-blue-100">
      <span className="text-2xl font-bold text-blue-700">L</span>
    </div>

    <h1 className="text-2xl font-bold uppercase tracking-wide text-stone-700">
      Login
    </h1>

    {/* <p className="text-sm text-gray-500">
      Sign in to continue
    </p> */}
  </CardHeader>

  <form onSubmit={handleSubmit}>
    <CardBody className="px-8 py-4">
      <div className="flex flex-col gap-5">

        <Input
          type="text"
          label="USERNAME"
          placeholder="Enter username"
          labelPlacement="outside"
          isRequired
          name="username"
          variant="bordered"
          value={formData.username}
          onChange={handleChange}
          isDisabled={isPending}
          classNames={{
            label: "text-xs font-semibold text-gray-700",
            inputWrapper:
              "rounded-xl border-gray-300 hover:border-blue-500 focus-within:border-blue-600 bg-white",
          }}
        />

        <Input
          label="PASSWORD"
          placeholder="Enter password"
          labelPlacement="outside"
          name="password"
          isRequired
          variant="bordered"
          value={formData.password}
          onChange={handleChange}
          isDisabled={isPending}
          type={isVisible ? "text" : "password"}
          classNames={{
            label: "text-xs font-semibold text-gray-700",
            inputWrapper:
              "rounded-xl border-gray-300 hover:border-blue-500 focus-within:border-blue-600 bg-white",
          }}
          endContent={
            <button
              type="button"
              className="text-gray-500 transition hover:text-blue-600"
              onClick={toggleVisibility}
            >
              <FontAwesomeIcon
                icon={isVisible ? faEyeSlash : faEye}
              />
            </button>
          }
        />

      </div>
    </CardBody>

    <CardFooter className="px-8 pb-8 pt-4">
      <Button
        color="primary"
        type="submit"
        isLoading={isPending}
        className="
          w-full
          rounded-xl
          bg-gradient-to-r
          from-stone-600
          to-slate-600
          font-semibold
          shadow-md
          transition
          hover:scale-[1.02]
          hover:shadow-lg
        "
      >
        LOGIN
      </Button>
    </CardFooter>
  </form>
</Card>
    </div>
  )
}

export default Login
